import styled from 'styled-components';
import { InfoIcon } from 'src/common/InfoIcon';

export const Box = styled.div`
  display: flex;
  align-items: flex-start;
  grid-gap: 10px;
  padding: 12px 14px;
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.dropZoneErrBg};
  border: 1px solid ${({ theme }) => theme.colors.dropZoneErrBorder};

  .edit-link {
    color: ${({ theme }) => theme.colors.prussianBlue};
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const AlertIcon = styled(InfoIcon)`
  margin-top: 2px;
`;
